import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { PopoverController } from "ionic-angular";

/**
 * Generated class for the SelectInputComponent component.
 *c
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: "select-search-input",
  templateUrl: "select-search-input.html",
})
export class SelectSearchInputComponent implements OnInit, AfterViewInit {
  // Configuration properties
  @Input() group: FormGroup;
  @Input() config;

  // Internal data model
  private emitRawData: Function = null;
  id: string;
  componentId: string;
  label: any;
  modalLabel: string;
  labelColor: string;
  options: string[] = [];
  placeholder: string = "pleaseSelect";
  innerGroup: FormGroup;
  required: boolean;
  showOther: boolean = false;
  disabled: boolean;
  readonly: boolean = false;
  multiple: boolean = false;
  ctData: string = "";

  constructor(
    public formBuilder: FormBuilder,
    private popover: PopoverController,
    public translatePipe: TranslateService
  ) {}

  ngOnInit(): void {
    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined ? this.config.label : this.config.id;
    if (this.label === "false") {
      this.label = false;
    }
    this.modalLabel = this.config.label === false ? this.id : this.label;
    this.readonly = this.config.readonly;
    this.multiple = this.config.multiple === true;
    if (this.config.options) {
      this.options = this.config.options;
    }
    if (this.config.placeholder) {
      this.placeholder = this.config.placeholder;
    }

    this.disabled = this.group.controls[this.id].disabled;
    this.innerGroup = this.formBuilder.group({});

    const validators = [];
    if (this.config.rules) {
      if (this.config.rules.required) {
        this.required = this.config.rules.required;
        validators.push(Validators.required);
      }
    }

    var composedValidators: ValidatorFn = Validators.compose(validators);

    this.group.addControl(this.id, this.formBuilder.control({}));
    this.group.controls[this.id].valueChanges.subscribe((data) => {
      if (data !== undefined) {
        this.ctData = data;
      }

      let outerDisabled = this.group.controls[this.id].disabled;
      if (outerDisabled !== this.disabled) {
        this.disabled = outerDisabled;
        if (this.disabled || this.readonly) {
          this.innerGroup.disable();
        } else {
          this.innerGroup.enable();
        }
      }
    });
    this.group.controls[this.id].setValue(this.group.controls[this.id].value);
    this.group.controls[this.id].setErrors(composedValidators);
  }

  ngAfterViewInit(): void {
    this.group.controls[this.id].setErrors(this.getErrors());

    this.group.valueChanges.subscribe((data) => {
      this.group.controls[this.id].setErrors(this.getErrors());
    });
  }

  getCurrentValue() {
    return this.group.controls[this.id].value;
  }

  getErrors(): ValidationErrors {
    let errors = {};
    if (
      this.required &&
      (undefined === this.getCurrentValue() || null === this.getCurrentValue())
    ) {
      errors["required"] = true;
    }

    return Object.keys(errors).length == 0 ? undefined : errors;
  }

  selectPopover(ev) {
    if (this.disabled || this.readonly) {
      return;
    }
    const options = this.config.options.map((member) => {
      return {
        name: this.translatePipe.instant(member),
        value: member,
      };
    });
    const searchable =
      this.config.options && this.config.options.length > 0 ? true : false;
    const searchPlaceholder = this.translatePipe.instant(this.placeholder);
    let emptyMessage = "No state found.";
    if (!this.config.options) {
      emptyMessage = "No state found.";
    } else {
      emptyMessage = "Select a state first.";
    }
    const popover = this.popover.create(
      "CareTeamsSelectPage",
      { options, searchable, searchPlaceholder, emptyMessage },
      { cssClass: "select-assessment-component-popover" }
    );
    popover.onDidDismiss((data) => {
      if (data) {
        this.ctData = data;
        this.group.controls[this.id].setValue(data);
      }
    });
    popover.present({ ev });
  }

  openModal(ev) {
    if (ev.keyCode == 13) {
      this.selectPopover(ev);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/select-search-input/select-search-input.ts